import Vue from 'vue'
import svgIcon from '@/components/SvgIcon'
import snackbar from '@/components/Snackbar'
import modal from '@/components/Modal'

Vue.component('modal', modal)
Vue.component('snackbar', snackbar)
Vue.component('svg-icon', svgIcon)
